import Cookies from 'js-cookie'
import { bcryptEncryption } from 'sky-engine/utils'
import CookieUtil from 'sky-engine/utils/auth'

import { getUserInfo, loginByUsername, loginByPhone, loginByFeiShu, logout, getOaUserInfo } from '@/api/login'

const user = {
  state: {
    status: CookieUtil.getStatus(), // 标志用户是否登录过
    name: '',
    baseInfo: {}
  },
  mutations: {
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_INFO: (state, baseInfo) => {
      state.baseInfo = baseInfo
    }
  },

  actions: {
    async LoginByUsername({ commit }, userInfo) {
      const userName = userInfo.userName
      const password = userInfo.password
      const bcryptjs = await import('bcryptjs')
      await loginByUsername(userName, bcryptEncryption(bcryptjs, password)).then(response => {
        // 标志已登录
        CookieUtil.setStatus(true)
        Cookies.set('XXXXX', '15_ex_login_out', { expires: 7 })
        commit('SET_STATUS', true)
      })
    },
    async LoginByPhone({ commit }, userInfo) {
      await loginByPhone(userInfo.telephoneNum, userInfo.verifyCode).then(response => {
        // 标志已登录
        CookieUtil.setStatus(true)
        commit('SET_INFO', response.data.content)
        commit('SET_STATUS', true)
      })
    },
    GetOaUserInfo({ commit, state }) {
      return getOaUserInfo({ ticket: Cookies.get('ticket') }).then(response => {
        const data = response.data
        if (
          data !== null &&
          typeof data === 'object' &&
          data.status === 'SUCCESS' &&
          data.loginStatus !== 'NO_AUTHORITY'
        ) {
          const content = response.data.content
          commit('SET_INFO', content)
          commit('SET_NAME', content.userName)
          this.dispatch('SetHasFirstTimeLoggedIn', content.hasFirstTimeLoggedIn)
          return response
        }
        return Promise.reject(response)
      })
    },

    GetFeiShuUserInfo({ commit, state }) {
      var tmp_token = CookieUtil.getToken()
      var wspToolClientId = Cookies.get('wspToolClientId')
      var token = tmp_token.replace('|first', '')
      return loginByFeiShu(token, wspToolClientId).then(response => {
        if (response.data !== null && typeof response.data === 'object' && response.data.status === 'SUCCESS') {
          // 由于mockjs 不支持自定义状态码只能这样hack
          const data = response.data.content
          commit('SET_INFO', data)
          commit('SET_NAME', data.userName)
          this.dispatch('SetHasFirstTimeLoggedIn', data.hasFirstTimeLoggedIn)
          return response
        }
        return Promise.reject(response)
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return getUserInfo().then(response => {
        if (response.data !== null && typeof response.data === 'object' && response.data.status === 'SUCCESS') {
          // 由于mockjs 不支持自定义状态码只能这样hack
          const data = response.data.content
          commit('SET_INFO', data)
          commit('SET_NAME', data.userName)
          this.dispatch('SetHasFirstTimeLoggedIn', data.hasFirstTimeLoggedIn)
          return response
        }
        return Promise.reject(response)
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return logout().then(response => {
        // 标志退出登录
        this.dispatch('FedLogOut')
      })
    },
    loginByFeiShu({ commit, state }, params) {
      CookieUtil.setToken(params['code'])
      CookieUtil.setStatus(true)
      commit('SET_STATUS', true)
    },
    wspToolByFeiShu({ commit, state }, params) {
      CookieUtil.setToken(params['code'])
      CookieUtil.setStatus(true)
      commit('SET_STATUS', true)
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_STATUS', false)
        commit('SET_NAME', '')
        commit('SET_CONFIGURATION_WIZARD_VISIBLE', false)
        commit('SET_CONFIGURATION_WIZARD_STEP', 0)
        CookieUtil.removeStatus()
        // 清理所有认证相关的Cookie，避免串掉问题
        // 优先级：先清理飞书标记，再清理OA票据
        const token = CookieUtil.getToken && CookieUtil.getToken()
        if (token && token.includes('|')) {
          // 飞书登录遗留的token标记
          CookieUtil.removeToken && CookieUtil.removeToken()
        }
        if (Cookies.get('ticket')) {
          Cookies.remove('ticket')
          const oaUrl = `https://sid.ruijie.com.cn/channel/logout?service=https://${window.location.host}`
          window.location = oaUrl
        } else {
          // 确保彻底清理，防止后续请求携带过期认证
          Cookies.remove('wspToolClientId')
          Cookies.remove('nextUrl')
          resolve()
        }
      })
    }
  },
  getters: {
    token: state => state.token,
    name: state => state.name,
    status: state => state.status
  }
}

export default user
